import React ,{useState, useEffect , useContext , useRef, useLayoutEffect}from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {motion }from 'framer-motion'
import { SearchContext } from './Contexts/Context'
import {Helmet} from 'react-helmet-async'
import {FaEnvelope, FaPhoneAlt , FaFacebookF , FaTwitter,FaYoutube, FaAngleLeft, FaInstagram} from 'react-icons/fa'
import {IoBasketballOutline} from 'react-icons/io5'
import {getMeriisSamsakhurebi} from '../service/service'
import joni from '../images/joni.jpeg'
function MeriaSamsakhurebi() {
  const navigate = useNavigate();
  const ref = useRef(null)
  const [width, setWidth] = useState(10)
  const [samsakhurebi, setSamsakhurebi] = useState([])
  const [loading, setLoading] = useState(true)
  const {language} = useContext(SearchContext)



  useEffect(() => {
    const meriisSamsaxurebi = async () => {
      try {
        await getMeriisSamsakhurebi().then(data =>  setSamsakhurebi(data));
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(true);
      } 
    };
    meriisSamsaxurebi();
  }, []);

  const SamsakhurebiView = ({ data }) => {

    return (
      <div className='column'>
      <div className='samsakhurebi-view'>
        <div className="samsakhurebi-content">
          <div className="samsakhurebi-image">
            <img src={data.image} alt="" />
          </div>
          <div className="samsakhurebi-text"
          ><h4>{data.position}</h4>
          <p>{data.full_name}</p>
          <a href={data.website}>www.khulo.gov.ge</a>
          <p>{data.address}</p>
          <a href={`tel:${data.mobile}`}>{data.mobile}</a>
          </div>
          <div className='samsakhurebi-button'>
            <Link to={`/meriis-samsakhurebi/${data.slug}`}>
              <p>დაწვრილებით</p>
            </Link>
          </div>
        </div>
      </div>
      </div>
    )
  }
 
 
  return (
    <motion.div
    intial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{opacity: 0}}>

<div className="margin-280px ">
        <header>
          <span className='big ' id='meria' ref={ref} style={{marginRight:  "50px"   }}> {language == 1 ? "მერია" : ""}
                      {language == 2 ? "KHULO CITY HALL" : ""}</span>

          <span>{  ( (language == 1 ? "სამსახურები "  : "menuName[1].name_eng)"))  }</span>
          {/* <Helmet><title>{   ((language == 1 ? menuName[1].name_geo   : menuName[1].name_eng))   }</title></Helmet> */}
        </header>
        <div>
          
          <div className='sakrebulo-landing'>
            <div className="landing-container">
              <div className='display-flex'>
              {loading ? <p>Loading...</p> : samsakhurebi.map(item => <SamsakhurebiView key={item.id} data={item} />)}
            </div>
            </div>
          </div>
          {/* <div className="presscenter-info">
       
          
             
            </div> */}
        </div>


          
      </div>

    </motion.div>
  )
}

export default MeriaSamsakhurebi